/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
export default {
  window,
  document,
};
